var map = {
	"./ChicaUno.webp": 4328,
	"./adminCimg.webp": 6781,
	"./becaEs.jpg": 8903,
	"./bioquimicayfsc.webp": 1542,
	"./calendario.webp": 2148,
	"./calendarioAca.jpg": 5345,
	"./carnet.webp": 5067,
	"./certificado.webp": 6979,
	"./chicaUnoCocha.png": 3588,
	"./chicaUnoShina.webp": 5787,
	"./chicaUnoT.webp": 6428,
	"./chicoPortadaY.webp": 2398,
	"./cocha.webp": 9618,
	"./conMed.jpg": 9726,
	"./conPol.jpg": 2789,
	"./conlat.jpg": 1835,
	"./contP.jpg": 9170,
	"./conta.webp": 6645,
	"./contaT.webp": 231,
	"./contop.jpg": 3653,
	"./convenio.jpg": 5135,
	"./derechoCimg.webp": 4488,
	"./derechoSc.webp": 6482,
	"./derechoYimg.jpg": 7050,
	"./enferT.webp": 1582,
	"./enfermeriaCimg.webp": 8740,
	"./enfsc.webp": 4127,
	"./expUno.webp": 1155,
	"./fisioCimg.webp": 4356,
	"./fisioSc.webp": 8414,
	"./fisioterapiaT.webp": 9184,
	"./fondoCocha.webp": 2328,
	"./fondoGeneralC.webp": 7653,
	"./fondoLibertad.webp": 1337,
	"./fondoNotiY.jpg": 4923,
	"./fondoNoticiasC.webp": 8541,
	"./fondoNoticiasShina.jpeg": 2052,
	"./fondoNoticiasT.webp": 252,
	"./fondoOferta.webp": 3165,
	"./fondoOfertaCocha.webp": 1579,
	"./fondoOfertaShina.webp": 7228,
	"./fondoOfertaT.webp": 415,
	"./fondoOfertaY.jpg": 4238,
	"./fondoRed.webp": 6127,
	"./fondoRedAlumni.jpg": 6797,
	"./fondoRedAlumni.webp": 2573,
	"./fondoRedAlumniCocha.webp": 4811,
	"./fondoRedAlumniShina.jpeg": 8805,
	"./fondoRedAlumniT.webp": 927,
	"./fondoRedAlumniY.jpg": 4844,
	"./fondoRequiY.jpg": 2675,
	"./fondoRequisitos.webp": 976,
	"./fondoRequisitosC.webp": 1989,
	"./fondoRequisitosSh.jpeg": 7566,
	"./fondoRequisitosT.webp": 3924,
	"./fondoShina.webp": 9467,
	"./fondoTarija.webp": 7803,
	"./fondoUnido.jpg": 619,
	"./fotos.webp": 6657,
	"./fundador.webp": 9617,
	"./graduados.webp": 5714,
	"./graduadosCohca.webp": 4256,
	"./graduadosShina.webp": 9065,
	"./graduadosT.webp": 4738,
	"./graduadosY.png": 6465,
	"./ingComY.jpg": 8046,
	"./ingresoAlumno.webp": 8389,
	"./ingresoDocente.webp": 7197,
	"./ingsc.webp": 4992,
	"./inscripciones.webp": 1187,
	"./lobo404.webp": 2500,
	"./logo.webp": 1869,
	"./logoN.png": 4295,
	"./logoUno.webp": 8307,
	"./mSC.webp": 8263,
	"./marcador.webp": 2631,
	"./mcb.webp": 4596,
	"./mediT.webp": 8137,
	"./medicinaCimg.webp": 6502,
	"./medicinaShi.webp": 1736,
	"./montero.webp": 104,
	"./mtr.webp": 7447,
	"./n.webp": 3576,
	"./noticias.webp": 7066,
	"./odontoT.jpg": 3029,
	"./odontologiaT.webp": 3325,
	"./odontosc.webp": 9287,
	"./pais.webp": 605,
	"./pantallaBienveniday.jpg": 3621,
	"./portada1.webp": 2718,
	"./prosc.jpg": 6289,
	"./rector.webp": 9237,
	"./santacruz.png": 431,
	"./shinaota.webp": 7705,
	"./tarija.webp": 5917,
	"./test.webp": 9698,
	"./titulo.webp": 4551,
	"./tituloHero.png": 8555,
	"./yacuhiba.png": 6396,
	"./yacuhiba.webp": 4586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8652;